import React from 'react';
import { nftMarketplaceUrl } from 'utils/socials';
import { GRIBBLE_CONTRACT_ADDRESS } from 'utils/contract';
import { GenericSharing } from './Generic';
import { ShareDropdownButton } from '../ShareDropdownButton';

export function EggSharing({ egg, text, align }: EggShareDropdownProps) {
  const openSeaLink = nftMarketplaceUrl.openSea({
    contract: GRIBBLE_CONTRACT_ADDRESS,
    nftId: egg.id,
  });

  const fallback = {
    text: `My DuskBreakers #GribbleEgg is evolving! Check it out on OpenSea: ${openSeaLink.toString()}`,
    link: openSeaLink,
  };

  return (
    <ShareDropdownButton data={fallback} text={text}>
      <GenericSharing
        openSeaLink={openSeaLink}
        data={{
          twitter: {
            text: `My DuskBreakers #GribbleEgg is evolving! Check it out on OpenSea: ${openSeaLink.toString()}`,
            link: openSeaLink,
          },
          telegram: {
            text: `My DuskBreakers #GribbleEgg is evolving! Check it out on OpenSea`,
            link: openSeaLink,
          },
          fallback,
        }}
        align={align}
      />
    </ShareDropdownButton>
  );
}

export type EggShareDropdownProps = {
  egg: { id: number };
  text?: string;
  align?: 'left' | 'right';
};
